import React, { useEffect, useState } from 'react';
import allImgPaths from "assets/images";
import useAppState from 'context/useAppState';
import { checkTaskAllocation, getNextBestActionsData } from 'services/event';
import { useParams } from 'react-router-dom';
import CustomCheckBox from 'components/CustomCheckBox';
import { cloneDeep } from 'lodash';
import { ACTUAL_TASK_NAMES, LOGISTICS_AND_OTHERS_ACTIONS_TABS } from 'utils/constant';
import LogisticsModal from 'components/common/modal/LogisticsModal';

const bestActionIcons = [
    { title: 'Recommend', icon: allImgPaths.suggestionBrainStorm },
    { title: 'Brainstorm', icon: allImgPaths.suggestionBrainStorm },
    { title: 'Create', icon: allImgPaths.suggestionBrainStorm },
    { title: 'View', icon: allImgPaths.suggestionView2 },
    { title: 'Draft', icon: allImgPaths.suggestionDraft },
    { title: 'Draft RFP', icon: allImgPaths.suggestionDraft },
    { title: 'Draft Agreement', icon: allImgPaths.suggestionDraft },
    { title: 'Explore', icon: allImgPaths.suggestionExplore },
    { title: 'Show Favorites', icon: allImgPaths.suggestionShowFavorite },
    { title: 'Show Favorite', icon: allImgPaths.suggestionShowFavorite },
    { title: 'Show Saved', icon: allImgPaths.suggestionShowSaved2 },
    { title: 'Show Pinned', icon: allImgPaths.suggestionShowSaved },
    { title: 'Upload Inspiration', icon: allImgPaths.suggestionUploadInspiration },
    { title: 'Upload', icon: allImgPaths.suggestionUpload },
    { title: 'Add/Upload', icon: allImgPaths.suggestionUpload },
    { title: 'Venue Inspired', icon: allImgPaths.suggestionVenueInspired },
    { title: 'Budget Allocations', icon: allImgPaths.suggestionView2 },
    { title: 'Enter Requirements', icon: allImgPaths.suggestionView2 },
]

const taskReplaces: any = {
    'Brainstorm event themes': ACTUAL_TASK_NAMES.THEMES.FETE,
    'Brainstorm decor styles': ACTUAL_TASK_NAMES.THEMES.DECOR,
    'Brainstorm venue styles': ACTUAL_TASK_NAMES.THEMES.VENUE,
    'Draft event program': ACTUAL_TASK_NAMES.FETE_PROGRAM.DRAFT,
    'Create budget allocations': ACTUAL_TASK_NAMES.BUDGET.ALLOCATION,
    'Brainstorm target audience': ACTUAL_TASK_NAMES.ATTENDEES.IDENTIFY_TARGET_AUDIENCE,
    'Draft attendee invitation': ACTUAL_TASK_NAMES.ATTENDEES.DRAFT_INVITATIONS,
    'Upload attendee list': ACTUAL_TASK_NAMES.ATTENDEES.CREATE_ATTENDEE_LIST,
    'Upload sample invitation': ACTUAL_TASK_NAMES.ATTENDEES.DRAFT_INVITATIONS,
    'Brainstorm speakers': ACTUAL_TASK_NAMES.SPECIAL_GUESTS_AND_SPEAKERS.IDENTIFY_SPEAKERS,
    'Brainstorm special Guests': ACTUAL_TASK_NAMES.SPECIAL_GUESTS_AND_SPEAKERS.IDENTIFY_SPECIAL_GUESTS,
    'Upload guests sample invitation': ACTUAL_TASK_NAMES.SPECIAL_GUESTS_AND_SPEAKERS.DRAFT_INVITATIONS,
    'Upload sample agreement': ACTUAL_TASK_NAMES.SPECIAL_GUESTS_AND_SPEAKERS.DRAFT_GUEST_AGREEMENTS,
    'Draft invitation': ACTUAL_TASK_NAMES.SPECIAL_GUESTS_AND_SPEAKERS.DRAFT_INVITATIONS,
    'Draft agreement': ACTUAL_TASK_NAMES.SPECIAL_GUESTS_AND_SPEAKERS.DRAFT_GUEST_AGREEMENTS,
    'Finalize Logistics': ACTUAL_TASK_NAMES.LOGISTICS_AND_OTHERS.FINALIZE_LOGISTICS,
    'Recommend venue': ACTUAL_TASK_NAMES.VENDOR.VENUE,
    'Recommend F&B vendor': ACTUAL_TASK_NAMES.VENDOR.CATERING,
    'Recommend Decor vendor': ACTUAL_TASK_NAMES.VENDOR.DECOR,
    'Recommend gift vendor': ACTUAL_TASK_NAMES.VENDOR.ENTERTAINMENT,
    'Draft agreement for venue vendor': ACTUAL_TASK_NAMES.VENDOR.VENUE,
    'Draft agreement for F&B vendor': ACTUAL_TASK_NAMES.VENDOR.CATERING,
    'Draft agreement for decor vendor': ACTUAL_TASK_NAMES.VENDOR.DECOR,
    'Draft agreement for gift vendor': ACTUAL_TASK_NAMES.VENDOR.ENTERTAINMENT
}

const SearchBarSuggestion = () => {
    const [showSuggestion, setShowSuggestion] = useState(false);
    const [suggestionActive, setSuggestionActive] = useState<any>(false);
    const [nextBestActions, setNextBestActions] = useState<any>([])
    const [activeCardActions, setActiveCardActions] = useState<any>([])
    const [activeCardSubActions, setActiveCardSubActions] = useState<any>([])
    const { selectedCardDetail } = useAppState('cardWrapper');
    const { setState: setEventDataState, sendButtonRef } = useAppState("eventData");
    const { setState: setChatBoxState } = useAppState("chatBox");
    const { id: eventId } = useParams();
    const [isTaskAllocated, setIsTaskAllocated] = useState(false);
    const [clickedMain, setClickedMain] = useState('');
    const [vendorRFPOptions, setVendorRFPOptions] = useState<any>([]);
    const [openLogisticsModal, setOpenLogisticsModal] = useState(false);
    const [defaultLogisticsTab, setDefaultLogisticsTab] = useState(LOGISTICS_AND_OTHERS_ACTIONS_TABS.meeting_spaces)

    useEffect(() => {
        if (selectedCardDetail && nextBestActions?.length) {
            setActiveAction(nextBestActions)
            setActiveCardSubActions([])
            setEventDataState({ bestActionQuery: null })
        }
    }, [selectedCardDetail])

    useEffect(() => {
        getNextBestActions()

        if (selectedCardDetail?.title == 'Budget') checkBudgetAllocation()
    }, [])

    const checkBudgetAllocation = async () => {
        const taskId = selectedCardDetail?.tasks?.find((t: any) => t.title.toLowerCase() == ACTUAL_TASK_NAMES.BUDGET.ALLOCATION.toLowerCase())?._id;
        const { data } = await checkTaskAllocation(eventId, { taskId })
        setIsTaskAllocated(data?.isAllocated);
    }

    const getNextBestActions = async () => {
        try {
            const { data }: any = await getNextBestActionsData();
            setNextBestActions(data)
            setActiveAction(data)

            if (selectedCardDetail?.title == 'Vendor') assignVendorRFP(data, 'Vendor')

        } catch (error) {
            console.log("Error nextBestAction =", error);
        }
    }

    const assignVendorRFP = (data: any[], mainTitle: string) => {
        const subActions = data.find((dt: any) => dt.card == mainTitle)?.actions.find((ac: any) => ac.title.toLowerCase() == 'draft rfp')?.subactions;
        setVendorRFPOptions(subActions)
    }

    const setActiveAction = (data: any[]) => {
        if (selectedCardDetail) {
            const activeCardData = data.find((nba: any) => nba.card.toLowerCase() == selectedCardDetail?.title.toLowerCase())
            setActiveCardActions(activeCardData?.actions || [])
        }
    }

    const handleSuggestion = () => {
        setShowSuggestion(!showSuggestion);
        setActiveCardSubActions([])
        setEventDataState({ bestActionQuery: null })
    }

    const openActiveAction = (index: number) => {
        setClickedMain(activeCardActions[index].title)
        const selectedSubActions = activeCardActions[index] || [];
        // Set sub menus if available
        if (selectedSubActions?.subactions?.length > 0) {
            if (selectedCardDetail?.title == 'Budget') {
                const updatedActions = updateActiveSubActions(selectedSubActions)
                setActiveCardSubActions(updatedActions)
            } else {
                setActiveCardSubActions(selectedSubActions)
            }
        } else {
            // Open upload modal when submenus are not available for like Upload inspiration
            setChatBoxState({ showUploadFileModal: true })
            setShowSuggestion(!showSuggestion);
            setActiveCardSubActions([])
        }
    }

    // Used only fot budget right now
    const updateActiveSubActions = (selectedAction: any) => {
        const subActions = selectedAction.subactions;
        if (isTaskAllocated) {
            const index = subActions.findIndex((sa: any) => sa.title == 'Create');
            if (index > -1) subActions.splice(index, 1)
            selectedAction['subactions'] = subActions
        } else {
            const elementsToRemove = ['Reset', 'View'];
            const updatedSubActions = subActions.filter((action: any) => !elementsToRemove.includes(action.title));
            selectedAction['subactions'] = updatedSubActions
        }
        return selectedAction
    }

    const createText = (acs: any, text: string, action: string) => {
        if (action == 'text') {
            // const textForQuery = activeCardSubActions?.title + ' ' + text;
            const textForQuery = text;
            setEventDataState({
                bestActionQuery: textForQuery,
                bestActionPrompt: acs?.promptKey || '',
                currentTaskObj: { promptKey: acs?.promptKey || '', ...getTaskNameAndId(text) }
            })  // To append prompt if action is text
            sendButtonRef.current = true;
        }
        if (action == 'upload') {
            setChatBoxState({ showUploadFileModal: true })
            setEventDataState({ bestActionPrompt: getTaskNameAndId(text), currentTaskObj: getTaskNameAndId(text) })  // To get the file type uploaded, like attendee-list, rfp, etc
        }
        if (action == 'modal') {
            const allTasks = selectedCardDetail?.tasks;
            const task = allTasks.find((at: any) => at?.title.toLowerCase() == taskReplaces['Finalize Logistics'].toLowerCase());
            setEventDataState({ currentTaskObj: { task_name: task?.title || null, task_id: task?._id || null } })
            setDefaultLogisticsTab(text)
            setOpenLogisticsModal(true)
        }
        setShowSuggestion(!showSuggestion);
        setActiveCardSubActions([])
    }

    const getTaskNameAndId = (text: any) => {
        if (!text) return null;
        console.log({ taskReplaces, text })
        const taskName = taskReplaces[text];
        const allTasks = selectedCardDetail?.tasks;
        console.log({ allTasks, taskName })

        const task = allTasks.find((at: any) => at?.title.toLowerCase() == taskName?.toLowerCase());
        console.log({ task })
        return {
            task_name: task?.title || null, task_id: task?._id || null
        }
    }

    const setActionIcon = (title: string) => {
        let icon: any = bestActionIcons.find((bi: any) => bi.title.toLowerCase() == title.toLowerCase())?.icon;
        return icon
    }

    const handleVendorOptionChange = (name: string, isChecked: boolean) => {
        let clonedOptions = cloneDeep(vendorRFPOptions);
        const selectedOptionIndex = clonedOptions.findIndex((co: any) => co.value == name);
        if (selectedOptionIndex > -1) {
            if (name == 'all') {
                clonedOptions = clonedOptions.map((co: any) => ({ ...co, checked: isChecked }))
            } else {
                clonedOptions[selectedOptionIndex]['checked'] = isChecked;

                const allIndex = clonedOptions.findIndex((co: any) => co.value == 'all');
                clonedOptions[allIndex]['checked'] = false;
            }
            setVendorRFPOptions(clonedOptions)
        }
    }

    const vendorRfpQuote = (acs: any) => {
        const selectedOptions = vendorRFPOptions.filter((vo: any) => vo.checked && vo.value != 'all').map((vo: any) => vo.value)
        if (selectedOptions?.length > 0) {
            const textForQuery = `Draft RFP for ${selectedOptions.join(', ')} vendors`

            setEventDataState({ bestActionQuery: textForQuery, bestActionPrompt: acs?.promptKey || '' })
            sendButtonRef.current = true;
            setShowSuggestion(!showSuggestion);
            setActiveCardSubActions([])
        }
    }

    return (
        <>
            {
                openLogisticsModal &&
                <LogisticsModal
                    isShowModal={openLogisticsModal}
                    defaultTab={defaultLogisticsTab}
                    setOpenLogisticsModal={setOpenLogisticsModal}
                    isViewMode={false}
                />
            }
            <div className="relative w-full">
                <img
                    onClick={handleSuggestion}
                    className="absolute cursor-pointer right-4 -top-[52px] transform hover:-translate-y-2 transition-all duration-500"
                    src={showSuggestion ? allImgPaths.chatbarSuggestionCloseIcon : allImgPaths.chatbarSuggestionOpenIcon}
                    alt=""
                />

                <div className={`${showSuggestion ? "block" : "hidden"} w-full max-w-[460px] bg-white absolute bottom-16 right-6 shadow-customShadow11 rounded-tl-lg rounded-tr-lg z-10`}>
                    <div className="bg-[#1E0AF5] rounded-tl-xl rounded-tr-xl">
                        <p className="text-white py-4 px-3">What would you like to today?</p>
                    </div>
                    <div className="flex">
                        <div className="w-[230px]">
                            <ul>

                                {activeCardActions.length > 0 && activeCardActions.map((item: any, index: number) => (
                                    <li
                                        key={index}
                                        onClick={() => openActiveAction(index)}
                                        className={`flex justify-between items-center hover:bg-[#E8E6FE] cursor-pointer px-3 py-3 border border-b-[#EAECF0] ${suggestionActive === index ? "bg-[#E8E6FE]" : "bg-[#fff]"} `}>

                                        <div className="flex items-center gap-x-2">
                                            <img
                                                src={setActionIcon(item.title)}
                                                className="w-[22px] h-[22px]"
                                            />
                                            <span className="text-base font-interSemiBold text-[#1E0AF5]">{item.title}</span>
                                        </div>

                                        <img src={allImgPaths.nextBlueIcon} alt="" />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="w-[230px]">
                            <ul className={`${activeCardSubActions?.subactions?.length > 0 ? "block" : "hidden"}`}>
                                {
                                    clickedMain != 'Draft RFP' &&
                                    activeCardSubActions?.subactions?.length > 0 && activeCardSubActions?.subactions.map((acs: any, index: number) => (
                                        <li
                                            className="text-base font-interSemiBold text-[#000] hover:text-[#1e0Af5] px-3 py-3 cursor-pointer"
                                            key={index}
                                            onClick={() => createText(activeCardSubActions, acs.value, acs.action)}
                                        >
                                            {acs.title}
                                        </li>
                                    ))
                                }

                                {
                                    selectedCardDetail?.title == 'Vendor' && clickedMain == 'Draft RFP' &&
                                    <>
                                        <div className='max-h-[400px] overflow-y-scroll'>
                                            {
                                                vendorRFPOptions?.length > 0 && vendorRFPOptions.map((op: any, oIndex: number) => (
                                                    <li
                                                        key={oIndex}
                                                        className="px-3 py-3"
                                                        onClick={() => { }}
                                                    >
                                                        <span className='mt-1'>
                                                            <CustomCheckBox
                                                                name={op.value}
                                                                label={op.title}
                                                                title={op.title}
                                                                customLabelStyle='text-base font-interSemiBold text-[#000] hover:text-[#1e0Af5] ml-2.5 truncate max-w-[170px]'
                                                                checked={op.checked}
                                                                onChange={handleVendorOptionChange}
                                                            />
                                                        </span>
                                                        {/* {op.title} */}
                                                    </li>
                                                ))
                                            }

                                            <div className="flex justify-center">
                                                <button
                                                    className={` submit-btn-blue !px-5 !py-2.5 !text-sm`}
                                                    onClick={() => vendorRfpQuote(activeCardSubActions)}>
                                                    Go
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                }
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default SearchBarSuggestion